// extracted by mini-css-extract-plugin
export default {"container":"SmallScreenMenu_container__aVLer","header":"SmallScreenMenu_header__Q8VUa","heading":"SmallScreenMenu_heading__k1wT4","content":"SmallScreenMenu_content__oz8VY"};